import RedirectButton from "app/pages/sales-intelligence/pages/home/components/common/RedirectButton/RedirectButton";
import withMouseEventHandlers from "app/pages/sales-intelligence/hoc/withMouseEventHandlers";
import withTrackedMouseEvents from "app/pages/sales-intelligence/hoc/withTrackedMouseEvents";
import homePageTrackingService from "app/pages/sales-intelligence/services/tracking/home-page/trackingService";
import type { ViewModelMetadata } from "app/pages/sales-intelligence/pages/home/types/models";

const RedirectButtonTracked = withTrackedMouseEvents(
    withMouseEventHandlers(RedirectButton),
    homePageTrackingService.cards.viewAllButton,
)<ViewModelMetadata>;

export default RedirectButtonTracked;
